import { api } from "@/lib/config";
import { useQuery } from "@tanstack/react-query";

export const useProjectEmployeeTimesheet = ({ departmentId, startDate, endDate, type } = {}) => {
    return useQuery({
        queryKey: ["employee-overview", departmentId, startDate, endDate, type],
        queryFn: async () => {
            const params = {
                startDate, endDate, departmentId, type
            }
            const response = await api.get(
                `get-employee-logged-vs-approved-timesheet`, { params }
            );
            return response?.data?.data || [];
        },
    });
};
